(function () {
  // Belt-and-suspenders for autoplay: the `autoplay` attribute normally
  // handles this on its own, but WebKit (Safari, and Chrome/iOS which is
  // WebKit underneath too) doesn't automatically retry a `play()` call that
  // was rejected because too little data had buffered yet — Chrome/desktop
  // does retry on its own, WebKit doesn't. Calling `.play()` immediately on
  // script load, before the browser has actually buffered anything, was
  // exactly that early rejected call with nothing following up on it. This
  // retries once real data is available (`canplay`), and again on the
  // page's first visibility/interaction as a last-resort net. All of it is
  // a no-op if native autoplay already succeeded on its own.
  function ensureAutoplay() {
    document.querySelectorAll('.daoud-video-hero__video').forEach(function (video) {
      if (video.dataset.autoplayBound) return;
      video.dataset.autoplayBound = 'true';

      function tryPlay() {
        video.muted = true;
        video.defaultMuted = true;
        var promise = video.play();
        if (promise && promise.catch) promise.catch(function () {});
      }

      tryPlay();

      function retryIfPaused() {
        if (video.paused) tryPlay();
      }

      video.addEventListener('canplay', retryIfPaused);
      video.addEventListener('loadeddata', retryIfPaused);

      function retryOnce() {
        retryIfPaused();
        document.removeEventListener('visibilitychange', retryOnce);
        document.removeEventListener('pointerdown', retryOnce);
      }
      document.addEventListener('visibilitychange', retryOnce);
      document.addEventListener('pointerdown', retryOnce, { once: true });
    });
  }

  function bindSoundToggle() {
    document.querySelectorAll('[data-daoud-sound-toggle]:not([data-bound])').forEach(function (button) {
      button.dataset.bound = 'true';
      var hero = button.closest('.daoud-video-hero');
      var video = hero && hero.querySelector('.daoud-video-hero__video');
      if (!video) return;
      button.addEventListener('click', function () {
        video.muted = !video.muted;
        button.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      });
    });
  }

  var MAX_OFFSET = 36;
  var STRENGTH = 0.12;
  var parallaxVideos = [];
  var ticking = false;

  function updateParallax() {
    parallaxVideos.forEach(function (video) {
      var rect = video.hero.getBoundingClientRect();
      var progress = rect.top;
      var offset = Math.max(-MAX_OFFSET, Math.min(MAX_OFFSET, -progress * STRENGTH));
      video.el.style.setProperty('--daoud-parallax-y', offset.toFixed(1) + 'px');
    });
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  }

  function bindParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.daoud-video-hero:not([data-parallax-bound])').forEach(function (hero) {
      hero.dataset.parallaxBound = 'true';
      var video = hero.querySelector('.daoud-video-hero__video');
      if (!video) return;
      parallaxVideos.push({ hero: hero, el: video });
    });
    if (parallaxVideos.length && !onScroll._bound) {
      document.addEventListener('scroll', onScroll, { passive: true });
      onScroll._bound = true;
      updateParallax();
    }
  }

  var IDLE_MS = 3000;

  function bindScrollHint() {
    document.querySelectorAll('.daoud-video-hero:not([data-scroll-hint-bound])').forEach(function (hero) {
      hero.dataset.scrollHintBound = 'true';
      var hint = hero.querySelector('[data-daoud-scroll-hint]');
      if (!hint) return;

      var timerId = null;

      function show() {
        hint.setAttribute('data-visible', 'true');
      }
      function hide() {
        hint.removeAttribute('data-visible');
      }
      function clearTimer() {
        if (timerId) {
          window.clearTimeout(timerId);
          timerId = null;
        }
      }
      function scheduleShow() {
        clearTimer();
        timerId = window.setTimeout(show, IDLE_MS);
      }

      hint.addEventListener('click', function () {
        hide();
        clearTimer();
        var rect = hero.getBoundingClientRect();
        window.scrollTo({ top: window.scrollY + rect.height, behavior: 'smooth' });
      });

      window.addEventListener(
        'scroll',
        function () {
          hide();
          clearTimer();
          // Only worth nudging again while still essentially at the top of the page.
          if (window.scrollY < 40) scheduleShow();
        },
        { passive: true }
      );

      if (window.scrollY < 40) scheduleShow();
    });
  }

  function bind() {
    ensureAutoplay();
    bindSoundToggle();
    bindParallax();
    bindScrollHint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();
